module.exports = __webpack_public_path__ + "static/img/03.01b5fbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/03.png
// module id = USOW
// module chunks = 1